import { AxiosResponse } from 'axios';
import { bexHttpClient } from '../../clients';

/**
 * Catalog READ access for the Surfaces editor. The catalog is the global,
 * versioned, immutable component vocabulary (managed/published in the Admin
 * Portal). Here we only read it to show authors which components/props are
 * allowed for a given catalogVersion. Backed by BeX Server.
 */
export interface CatalogComponentDef {
    properties?: Record<string, unknown>;
}
export interface Catalog {
    version: string;
    components: Record<string, CatalogComponentDef>;
    notes?: string;
}

class CatalogReadService {
    async getVersion(version: string): Promise<AxiosResponse> {
        return bexHttpClient.get(`/redis/catalog/${encodeURIComponent(version)}`);
    }

    async getLatest(): Promise<AxiosResponse> {
        return bexHttpClient.get('/redis/catalog/latest');
    }

    async listVersions(): Promise<AxiosResponse> {
        return bexHttpClient.get('/redis/catalog/versions');
    }
}

const catalogReadService = new CatalogReadService();
export { catalogReadService };
